/**
 * useDatabaseConnections Hook
 *
 * Custom React Query hook for fetching database connections list.
 */

import { useQuery } from '@tanstack/react-query';
import { databaseConnectionService } from '../../../api/database-connection.service';
import type { DatabaseConnectionListQuery } from '../../../types/database-connection.types';

/**
 * Hook for fetching database connections
 * @param tenantId - Tenant ID
 * @param query - Optional query parameters (search, type, isActive, limit)
 */
export const useDatabaseConnections = (tenantId: string, query?: DatabaseConnectionListQuery) => {
  return useQuery({
    queryKey: ['database-connections', tenantId, query],
    queryFn: async () => {
      const result = await databaseConnectionService.listDatabaseConnections(tenantId, query);
      return result;
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
